import React, { useState, useEffect, Fragment } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search } from "react-feather"
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "../@core/layouts/VerticalLayout"
import { isUserLoggedIn } from "../utility/Utils"
import themeConfig from '../configs/themeConfig'
import { useSelector } from "react-redux"
import ComponentSpinner from '../components/spinner/Loading-spinner'
// import store from '../views/redux/store'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const [menusData, setMenuData] = useState([])
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee
  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  useEffect(() => {
    if (isUserLoggedIn()) {
      if (isEmployee) {
        if (JSON.parse(isUserLoggedIn()).isEmployee) {
          const tempMenuData = [
            {
              id: "home",
              title: "Home",
              icon: '',
              img: themeConfig.navicons.home,
              img1: themeConfig.navicons.home1,
              color1: '#fff',
              color2: '#313131',
              navLink: "/home",
              show: true
            },
            {
              id: "dashboard",
              title: "Dashboard",
              icon: '',
              img: themeConfig.navicons.dashboard,
              img1: themeConfig.navicons.dashboard1,
              color1: '#fff',
              color2: '#313131',
              navLink: "/dashboard",
              show: true
            },
            {
              id: "workOrders",
              title: "Work Orders",
              icon: '',
              img: themeConfig.navicons.Search,
              img1: themeConfig.navicons.Search1,
              color1: '#fff',
              color2: '#313131',
              navLink: "/search",
              show: true
            },
            {
              id: "account",
              title: "Account",
              icon: '',
              img: themeConfig.navicons.Profile,
              img1: themeConfig.navicons.Profile1,
              color1: '#fff',
              color2: '#313131',
              navLink: "/my-profile",
              show: true
            }
          ]
          const userData = JSON.parse(localStorage.getItem('userData'))
          const userRoles = userData?.userRoles
          const isAdmin = userRoles?.some(find => find.rId === 1)
          if (isAdmin) {
            tempMenuData.push(
              {
                id: "appSettings",
                title: "Role Management",
                icon: '',
                img: themeConfig.navicons.appSettings,
                img1: themeConfig.navicons.appSettings1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/role-management",
                show: true
              },
              {
                id: "apostille",
                title: "Apostille",
                img: themeConfig.navicons.key,
                img1: themeConfig.navicons.key1,
                icon: '',
                show: true,
                color1: '#fff',
                color2: '#313131',
                navLink: "/apostillePermissions",
                children: [
                  {
                      id: "permissions",
                      title: "Permissions",
                      img: themeConfig.navicons.key,
                      img1: themeConfig.navicons.key1,
                      icon: '',
                      show: true,
                      color1: '#fff',
                      color2: '#313131',
                      navLink: "/apostillePermissions"
                  },
                  {
                      id: "log",
                      title: "Logs",
                      img: themeConfig.navicons.invoiceD1,
                      img1: themeConfig.navicons.invoiceD2,
                      icon: '',
                      show: true,
                      color1: '#fff',
                      color2: '#313131',
                      navLink: "/apostilleLogs"
                  }
                ]
              }
            )
          } else {
            // const superWORW = userRoles?.some(find => (find.rId === 2 || find.rId === 3))
            // const WORW = userRoles?.some(find => (find.wtId === 3 || find.wtId === 4))
            const isRole = userRoles?.find(find => find.rId)
            if (isRole) {
              tempMenuData.push(
                {
                  id: "apostille",
                  title: "Apostille",
                  img: themeConfig.navicons.key,
                  img1: themeConfig.navicons.key1,
                  icon: '',
                  show: true,
                  color1: '#fff',
                  color2: '#313131',
                  navLink: "/apostilleLogs",
                  children: [
                    {
                        id: "log",
                        title: "Logs",
                        img: themeConfig.navicons.invoiceD1,
                        img1: themeConfig.navicons.invoiceD2,
                        icon: '',
                        show: true,
                        color1: '#fff',
                        color2: '#313131',
                        navLink: "/apostilleLogs"
                    }
                  ]
                }
              )
            }
          }
          setMenuData(tempMenuData)
        }
      } else {
        if (stores?.acSpinner) {
          if (stores?.unauthorize && !isEmployee) {
            setMenuData([])
          }
          if (!stores.unauthorize && !isEmployee) {
            setMenuData([
              {
                id: "home",
                title: "Home",
                icon: '',
                img: themeConfig.navicons.home,
                img1: themeConfig.navicons.home1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/home",
                show: true
              },
              {
                id: "dashboard",
                title: "Dashboard",
                icon: '',
                img: themeConfig.navicons.dashboard,
                img1: themeConfig.navicons.dashboard1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/dashboard",
                show: true
              },
              {
                id: "workOrders",
                title: "Work Orders",
                icon: '',
                img: themeConfig.navicons.Search,
                img1: themeConfig.navicons.Search1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/search",
                show: true
              },
              {
                id: "account",
                title: "Account",
                icon: '',
                img: themeConfig.navicons.Profile,
                img1: themeConfig.navicons.Profile1,
                color1: '#fff',
                color2: '#313131',
                navLink: "/my-profile",
                show: true
              }
            ])
          }
        }
      }

    }
  }, [isUserLoggedIn(), stores.unauthorize, stores?.acSpinner])

  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
